import { Box } from '@cmpsr/components';
import { AnimatePresence, motion } from 'motion/react';

type WizardProgressIndicatorProps = {
  active?: boolean;
  key: number;
};

export default function WizardProgressIndicator(props: WizardProgressIndicatorProps) {
  return (
    <AnimatePresence mode="wait">
      <Box
        as={motion.div}
        key={props.key}
        display="inline-block"
        w={2}
        h={2}
        initial={{ backgroundColor: props.active ? 'transparent' : 'var(--chakra-colors-accent-default)' }}
        animate={{ backgroundColor: props.active ? 'var(--chakra-colors-accent-default)' : 'transparent' }}
        exit={{ backgroundColor: props.active ? 'transparent' : 'var(--chakra-colors-accent-default)' }}
        transition={{ base: '.3s' }}
        border="1px solid"
        borderColor="accent-default"
        borderRadius="50%"
      />
    </AnimatePresence>
  );
}
